import React from 'react';
import { twMerge } from 'tailwind-merge';

interface LogoProps {
  dark?: boolean;
  className?: string;
}
export default function Logo({ dark = false, className }: LogoProps): JSX.Element {
  return (
    <img
      className={twMerge('h-10 w-auto cursor-pointer', className)}
      src={`${process.env.PUBLIC_URL}/assets/logo/logo_name_${dark ? 'dark_' : ''}${process.env.REACT_APP_APPLICATION_VERSION === 'BUSINESS' ? 'business' : 'community'}.svg`}
      alt="Vera Connect"
    />
  );
}
